/* eslint-disable no-unused-vars */
import { useCallback, useEffect, useState } from 'react'
import { useNavigate, NavigateFunction } from 'react-router-dom'

import {
  PaymentInvoiceCurrencyChoices,
  InvoiceNode,
  useInvoiceQuery,
} from '@/apollo/graphql'
import { homePath, transformData } from '@/utils'
import { TFormSubmit } from '@/types'
import { useAPI } from '@/hooks'

interface IUseData {
  id?: string
}

interface IUseDataRes {
  loading?: boolean
  submitting: boolean
  data: Partial<InvoiceNode> | undefined
  onSubmit?: TFormSubmit<InvoiceNode>
  onCancel: () => void
}

const defaultData: Partial<InvoiceNode> = {
  currency: PaymentInvoiceCurrencyChoices.Ils,
}

export const useData = ({ id }: IUseData): IUseDataRes => {
  const navigate: NavigateFunction = useNavigate()
  const { submitting, sendForm } = useAPI()
  const [data, setData] = useState<Partial<InvoiceNode>>(defaultData)

  const { loading, refetch } = useInvoiceQuery({
    skip: !id,
    fetchPolicy: 'network-only',
    variables: {
      id: id || '',
    },
    onCompleted: res => {
      if (res.invoice) {
        // @ts-ignore
        setData({
          ...(res.invoice || {}),
          currency: res.invoice.currency || PaymentInvoiceCurrencyChoices.Ils,
        })
      }
    },
  })

  useEffect(() => {
    if (!id) {
      setData(defaultData)
    }
  }, [id])

  const onSubmit: TFormSubmit<InvoiceNode> = useCallback(
    (path, isEdit, callback) => d => {
      sendForm(
        {
          path,
          method: isEdit ? 'PUT' : 'POST',
          data: transformData(d),
          callback: e => {
            callback?.(e)
            refetch()
          },
        },
        { showNotify: true },
      )
    },
    [refetch, sendForm],
  )

  const onCancel = useCallback(() => {
    navigate(homePath)
  }, [navigate])

  return {
    loading,
    submitting,
    data,
    onSubmit,
    onCancel,
  }
}
